import { useRef } from "react";
import ReportCustomerVoucherList from "./ReportCustomerVoucherList";

const ReportCustomerVoucherMain = (props) => {
  const listRef = useRef(null);

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ReportCustomerVoucherList ref={listRef} />
    </div>
  );
};

export default ReportCustomerVoucherMain;
